var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c(
        "v-container",
        [
          _c("Slider"),
          _c(
            "v-card",
            {
              staticClass: "giftcode-news",
              attrs: { outlined: "", elevation: "3" },
            },
            [_c("GiftcodeNew")],
            1
          ),
          _c("GameComp"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }